import script from "./AccountHistoryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountHistoryComponent.vue?vue&type=script&setup=true&lang=js"

import "./AccountHistoryComponent.vue?vue&type=style&index=0&id=261b419f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-261b419f"]])

export default __exports__